import React from "react"
import styled from "styled-components"

export interface SliderSwitcherProps extends React.HTMLAttributes<HTMLDivElement> {
    active: boolean
    title: string
    reverseAlign?: boolean
}

const Title = styled.div`
    margin-right: 12px;
    font-family: ${(props) => props.theme.openSans};
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
`
const SliderWrapper = styled.div<{
    active: boolean
}>`
    display: flex;
    justify-content: ${(props) => (props.active ? "end" : "start")};
    width: 40px;
    height: 20px;
    margin-right: 12px;
    padding: 3px;
    border-radius: 10px;
    background: ${(props) => (props.active ? props.theme.sliderSwitcherActiveBackground : props.theme.sliderSwitcherInactiveBackground)};
    transition: ${(props) => props.theme.defaultTransition};
`
const SliderButton = styled.div`
    width: 14px;
    height: 14px;
    border-radius: 7px;
    background: ${(props) => props.theme.sliderSwitcherButtonColor};
    transition: ${(props) => props.theme.defaultTransition};
`
const SwitcherWrapper = styled.div<{
    reverseAlign: boolean
}>`
    display: flex;
    flex-direction: ${(props) => (props.reverseAlign ? "row-reverse" : "row")};
    align-items: center;
    margin-right: 12px;
    cursor: pointer;

    &:focus, &:active {
        & ${SliderButton} {
            width: 20px;
        }
    }
`

export const SliderSwitcher = ({
    active,
    title,
    reverseAlign = false,
    ...other
}: SliderSwitcherProps) => (
    <SwitcherWrapper
        reverseAlign={reverseAlign}
        {...other}
    >
        <SliderWrapper active={active}>
            <SliderButton />
        </SliderWrapper>
        <Title>{title}</Title>
    </SwitcherWrapper>
)
